<template lang="pug">
v-container(fluid='')
      v-card
        v-tabs.mt-4(v-model='activeTab')
          v-tab Art&iacute;culos
          v-tab Unidades de Medida
        v-tabs-items(v-model='activeTab')
          v-tab-item
            v-card-title.d-flex.justify-space-between
              span Gesti&oacute;n de Art&iacute;culos
              v-btn(color='primary', @click='openDialog()')
                v-icon(left='') mdi-plus
                | Nuevo Art&iacute;culo
            v-card-text
              v-data-table(:headers='headers', :items='items', :loading='loading', :search='search')
                template(v-slot:item.units='{ item }')
                  v-chip.mr-1(v-for='unit in item.units', :key='units._id', small='', close='')
                    | {{ unit.name }}
                template(v-slot:item.suppliers='{ item }')
                  v-chip.mr-1(v-for='supplier in item.suppliers', :key='supplier._id', small='', close='', @click:close='removeSupplier(item, supplier._id)')
                    | {{ supplier.businessName }}
                template(v-slot:item.latestCost.cost='{ item }')
                  span(:class="{'success--text': item.latestCost.cost < item.cost}")
                  | ${{ item.latestCost.cost }}
                template(v-slot:item.latestCost.date='{ item }')
                  | {{ formatDate(item.latestCost.date) }}
                template(v-slot:top='')
                  v-text-field.mx-4(v-model='search', label='Buscar artículo', prepend-inner-icon='mdi-magnify', clearable='')
                template(v-slot:item.stock='{ item }')
                    v-chip(:color='getStockColor(item.stock)', small='')
                      | {{ item.stock }}
                template(v-slot:item.actions='{ item }')
                      v-btn.mr-2(icon='', small='', @click='openDialog(item)')
                        v-icon mdi-pencil
                      v-btn(icon='', small='', color='error', @click='deleteItem(item)')
                        v-icon mdi-delete
          v-tab-item
            v-card(flat='')
              v-card-title.d-flex.justify-space-between
                span Unidades de Medida
                v-btn(color='primary', @click='openUnitDialog()')
                  v-icon(left='') mdi-plus
                  |  Nueva Unidad
              v-card-text
                v-data-table(:headers='unitHeaders', :items='units', :loading='loading')
                  template(v-slot:item.active='{ item }')
                    v-switch(v-model='item.active', @change='updateUnit(item)', dense='', inset='')
                  template(v-slot:item.actions='{ item }')
                    v-btn.mr-2(icon='', small='', @click='openUnitDialog(item)')
                      v-icon mdi-pencil
                    v-btn(icon='', small='', color='error', @click='deleteUnit(item)')
                      v-icon mdi-delete
      // Unit Dialog
      v-dialog(v-model='unitDialog', max-width='500')
        v-card
          v-card-title
            | {{ editedUnit._id ? &apos;Editar&apos; : &apos;Nueva&apos; }} Unidad de Medida
          v-card-text
            v-form(ref='unitForm', v-model='unitValid')
              v-text-field(v-model='editedUnit.name', label='Nombre', :rules="[v => !!v || 'El nombre es requerido']", required='')
              v-switch(v-model='editedUnit.active', label='Activa', color='success')
          v-card-actions
            v-spacer
            v-btn(text='', @click='closeUnitDialog') Cancelar
            v-btn(color='primary', :disabled='!unitValid', @click='saveUnit')  Guardar
      // Dialog for creating/editing items
      v-dialog(v-model='dialog', max-width='600')
        v-card
          v-card-title
            | {{ editedItem._id ? &apos;Editar&apos; : &apos;Nuevo&apos; }} Art&iacute;culo
          v-card-text
            v-form(ref='form', v-model='valid')
              v-text-field(v-model='editedItem.code', label='Código', :rules="[v => !!v || 'El código es requerido']", required='')
              v-text-field(v-model='editedItem.name', label='Nombre', :rules="[v => !!v || 'El nombre es requerido']", required='')
              v-textarea(v-model='editedItem.description', label='Descripción', rows='3')
              v-select(v-model='editedItem.units', :items='units', multiple='', item-text='name', item-value='_id', label='Unidad de medida', :rules="[v => !!v || 'Selecciona una unidad de medida']", required='')
              v-select(v-model='editedItem.suppliers', :items='suppliers', multiple='', item-text='businessName', item-value='_id', label='Proveedor', :rules="[v => !!v || 'Selecciona un proveedor']", required='')
              v-text-field(v-model.number='editedItem.minStock', label='Stock Mínimo', type='number', min='0', :rules="[v => v >= 0 || 'El stock mínimo no puede ser negativo']", required='')
          v-card-actions
            v-spacer
            v-btn(text='', @click='closeDialog')
              | Cancelar
            v-btn(color='primary', :disabled='!valid', @click='save')
              | Guardar
      item-supplier-dialog(v-model='supplierDialog', :item='selectedItem', @saved='fetchItems' v-if='selectedItem')
</template>
<script>
import { mapState } from 'vuex'
import ItemSupplierDialog from '../../../components/management/ItemSupplierDialog.vue'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
export default {
  name: 'ItemsView',
  components: {
    ItemSupplierDialog
  },
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    search: '',
    categoryFilter: null,
    supplierDialog: false,
    selectedItem: null,
    activeTab: 0,
    unitDialog: false,
    unitValid: false,
    unitHeaders: [
      { text: 'Nombre', value: 'name' },
      { text: 'Activa', value: 'active' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    editedUnit: {
      name: '',
      active: true
    },
    defaultUnit: {
      name: '',
      active: true
    },
    headers: [
      { text: 'Código', value: 'code' },
      { text: 'Nombre', value: 'name' },
      { text: 'Stock', value: 'stock' },
      { text: 'Stock Mínimo', value: 'minStock' },
      { text: 'Unidad de medida', value: 'units' },
      { text: 'Proveedores', value: 'suppliers' },
      { text: 'Último Costo', value: 'latestCost.cost' },
      { text: 'Proveedor', value: 'latestCost.supplier' },
      { text: 'Fecha', value: 'latestCost.date' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    editedItem: {
      code: '',
      name: '',
      description: '',
      stock: 0,
      minStock: 0,
      cost: 0
    },
    defaultItem: {
      code: '',
      name: '',
      description: '',
      stock: 0,
      minStock: 0,
      cost: 0
    }
  }),
  computed: {
    ...mapState({
      items: state => state.items.list,
      suppliers: state => state.suppliers.list
    }),
    units() {
      return this.$store.state.units.list
    },
    filteredItems() {
      let filtered = [...this.items]
      if (this.itemFilter) {
        filtered = filtered.filter(p => p.item._id === this.itemFilter)
      }
      return filtered
    }
  },
  methods: {
    openUnitDialog(unit = null) {
      this.editedUnit = unit ? { ...unit } : { ...this.defaultUnit }
      this.unitDialog = true
    },
    closeUnitDialog() {
      this.unitDialog = false
      this.$nextTick(() => {
        this.editedUnit = { ...this.defaultUnit }
        this.$refs.unitForm.reset()
      })
    },
    async saveUnit() {
      if (!this.$refs.unitForm.validate()) return
      try {
        if (this.editedUnit._id) {
          await this.$store.dispatch('units/update', this.editedUnit)
          this.$toast.success('Unidad actualizada')
        } else {
          await this.$store.dispatch('units/create', this.editedUnit)
          this.$toast.success('Unidad creada')
        }
        this.closeUnitDialog()
      } catch (error) {
        this.$toast.error('Error al guardar la unidad')
      }
    },
    async updateUnit(unit) {
      try {
        await this.$store.dispatch('units/update', unit)
      } catch (error) {
        unit.active = !unit.active // Revert change
        this.$toast.error('Error al actualizar la unidad')
      }
    },
    async deleteUnit(unit) {
      if (!confirm('¿Estás seguro de eliminar esta unidad?')) return
      try {
        await this.$store.dispatch('units/delete', unit._id)
        this.$toast.success('Unidad eliminada')
      } catch (error) {
        this.$toast.error('Error al eliminar la unidad')
      }
    },
    fetchItems() {
      try {
        this.$store.dispatch('items/fetch')
      } catch (error) {
        this.$toast.error('Error al cargar los artículos')
      } finally {
        this.loading = false
      }
    },
    openSupplierDialog(item) {
      this.selectedItem = item
      this.supplierDialog = true
    },
    async removeSupplier(item, supplierId) {
      try {
        await this.$http.delete(`/items/${item._id}/suppliers/${supplierId}`)
        this.$toast.success('Proveedor desasociado')
        await this.fetchItems()
      } catch (error) {
        this.$toast.error('Error al desasociar proveedor')
      }
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy', { locale: es })
    },
    getStockColor(stock) {
      if (stock <= 0) return 'error'
      if (stock <= this.editedItem.minStock) return 'warning'
      return 'success'
    },
    openDialog(item = null) {
      this.editedItem = item ? { ...item } : { ...this.defaultItem }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.$refs.form.reset()
      })
    },
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        if (this.editedItem._id) {
          await this.$store.dispatch('items/update', this.editedItem)
          this.$toast.success('Artículo actualizado')
        } else {
          await this.$store.dispatch('items/create', this.editedItem)
          this.$toast.success('Artículo creado')
        }
        this.closeDialog()
      } catch (error) {
        this.$toast.error('Error al guardar el artículo')
      }
    },
    async deleteItem(item) {
      if (confirm('¿Estás seguro de eliminar este artículo?')) {
        try {
          await this.$store.dispatch('items/delete', item._id)
          this.$toast.success('Artículo eliminado')
        } catch (error) {
          this.$toast.error('Error al eliminar el artículo')
        }
      }
    }
  },
  async created() {
    this.loading = true
    try {
      await this.$store.dispatch('items/fetch')
      await this.$store.dispatch('suppliers/fetch')
      await this.$store.dispatch('units/fetch')
    } catch (error) {
      this.$toast.error('Error al cargar los artículos')
    } finally {
      this.loading = false
    }
  }
}
</script>
